import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { first, sortBy } from 'lodash';
import ClaimJobDataPointsInputs from 'module/claims/views/claim/other/Claim.Job.DataPoints.Inputs';
import { useEffect } from 'react';
import { usePublicClaimSubmitProvider } from '../../Claim.Submit.Hooks';

export default function ClaimSubmitClaimJobDataPoints() {
  const { lang } = getLocales();
  const { form, claimTypes, claimJobForUpdate, updateClaimJob } = usePublicClaimSubmitProvider();

  const updateValue = (value: string, id: number) => {
    const updatedDataPoints = first(form.data?.claim?.claimJobs)?.dataPoints?.map((item) =>
      item.claimTypeDataPointId === id ? { ...item, value } : item
    );
    updateClaimJob({ ...first(form.data?.claim?.claimJobs), dataPoints: updatedDataPoints });
  };

  useEffect(() => {
    const updatedClaimJob = first(form.data?.claim?.claimJobs);
    const newDataPoints = sortBy(
      claimTypes
        ?.find((it) => it.id === claimJobForUpdate?.claimTypeId)
        ?.claimTypeDataPoints?.map((it) => ({
          claimTypeDataPointId: it.id,
          claimTypeId: it.claimTypeId,
          name: it.name,
          type: it.type,
          version: it.version,
          isRequired: it.isRequired,
          value: undefined,
        })),
      (it) => it.claimTypeDataPointId
    );

    updatedClaimJob.dataPoints = newDataPoints;

    updateClaimJob({ ...updatedClaimJob });
  }, [first(form.data?.claim?.claimJobs)?.claimTypeId]);

  return (
    !!first(form.data?.claim?.claimJobs)?.dataPoints?.length && (
      <div style={{ marginLeft: Theme.Size.L, marginRight: Theme.Size.L }}>
        <h2 style={{ display: 'flex', justifyContent: 'space-between' }}>{lang.details}</h2>
        <ClaimJobDataPointsInputs dataPoints={first(form.data?.claim?.claimJobs)?.dataPoints} onUpdate={updateValue} />
      </div>
    )
  );
}
